import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolder = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.5 31.25H33.5C34.1188 31.25 34.625 30.7437 34.625 30.125V13.25C34.625 12.6312 34.1188 12.125 33.5 12.125H23.0023C21.7859 12.125 20.5977 11.7312 19.6273 11L16.9273 8.975C16.7305 8.82734 16.4984 8.75 16.2523 8.75H6.5C5.88125 8.75 5.375 9.25625 5.375 9.875V30.125C5.375 30.7437 5.88125 31.25 6.5 31.25ZM33.5 34.625H6.5C4.01797 34.625 2 32.607 2 30.125V9.875C2 7.39297 4.01797 5.375 6.5 5.375H16.2523C17.2227 5.375 18.1719 5.69141 18.9523 6.275L21.6523 8.3C22.0391 8.59531 22.5172 8.75 23.0023 8.75H33.5C35.982 8.75 38 10.768 38 13.25V30.125C38 32.607 35.982 34.625 33.5 34.625Z" })
});
export default SvgFolder;
